import { render } from "./VmsSidebarCamerasTab.vue?vue&type=template&id=510c6e47&ts=true"
import script from "./VmsSidebarCamerasTab.vue?vue&type=script&lang=ts"
export * from "./VmsSidebarCamerasTab.vue?vue&type=script&lang=ts"

import "./VmsSidebarCamerasTab.vue?vue&type=style&index=0&id=510c6e47&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__